import Avatar        from 'avatar';
import Connection    from 'connection';
import Dialog        from 'dialogview';
import Formatter     from 'formatter';
import RenderReasons from 'renderreasons';

import template      from './avatar-chooser-dialog.hbs';
import './avatar-chooser-dialog.scss';

let Super = Dialog.prototype;

export default Dialog.extend({

    showInstant: true,
    hideInstant: true,

    className: 'avatar-chooser-dialog avatars-on accountContainer',

    template,

    events: _.extend({}, Super.events, {
        'click .avatar-chooser__item': 'chooseAvatar',
        'buttonClick .avatar-chooser__add': 'chooseUpload',
        'buttonClick .avatar-chooser__clear': 'chooseClear',
        'submit .avatar-chooser__selected': 'onSubmit',
    }),

    initialize: function (options) {
        Super.initialize.apply(this, arguments);

        this.formatter = new Formatter();
        this.model.bind('avatarPrompt', this.renderAvatars, this);
    },

    closed () {
        Super.closed.apply(this, arguments);
    },

    chooseAvatar (e) {
        e.preventDefault();
        this.renderAvatars(this.target, _.extend({}, this.options, {
            selected: $(e.currentTarget).data('id')
        }));
    },

    chooseClear (e) {
        e.preventDefault();
        this.renderAvatars(this.target, _.extend({}, this.options, {
            selected: null,
            clear: true
        }));
    },

    chooseUpload (e) {
        e.preventDefault();
        this.hide();
        this.model.trigger('avatarUploadPrompt', this.target, this.options);
    },

    onSubmit: function (e) {
        e.preventDefault();
        var form = $(e.currentTarget);
        var data = _.extend({}, this.options.properties, form.serializeForm());
        form.addSpin();
        this.$('userError').hide();
        this.model.post('set-avatar', data, (response) => {
            form.removeSpin();
            if (response.success) {
                this.hide();
            } else {
                this.renderAvatars(this.target, _.extend({}, this.options, {
                    error: RenderReasons.renderPostError(response)
                }));
            }
        });
    },
    
    renderAvatars (target, options = {}) {
        this.options = options;
        this.target = target;
        var selected = this.options.selected;
        var primary = false;
        var isPrimaryChecked = false;
        var current = this.target.get('avatar');
        var hasCurrent = !!current;
        var connection;
        if (this.target instanceof Connection) {
            connection = {
                name: this.target.getDisplayName(),
                nick: this.target.getNick()
            };
        }
        if (this.target === this.model) {
            isPrimaryChecked = primary = true;
        }
        var avatars = _.map(this.model.getAvatars(current), function (av) {
            av.connections = _.map(av.connections, function (c) {
                return {
                    name: c.getDisplayName(),
                    nick: c.getNick()
                };
            }, this);
            if (current && current == av.id) {
                av.isCurrent = true;
                if (!selected && !this.options.clear) {
                    selected = av.id;
                }
            }
            if (selected && selected == av.id) {
                av.isSelected = true;
                selected = av;
                if (selected.primary) {
                    isPrimaryChecked = true;
                }
            }
            av.image64 = this.formatter.imageAvatar(av.template, true, {
                size: 64,
                standalone: true
            });
            av.image256 = this.formatter.imageAvatar(av.template, true, {
                size: 256,
                standalone: true
            });
            return av;
        }, this);
        var isDefaultDisabled = isPrimaryChecked || !selected;
        if (avatars.length) {
            var data = {
                hasCurrent,
                connection,
                selected,
                avatars,
                primary,
                isPrimaryChecked,
                isDefaultDisabled,
                error: this.options.error
            };
            this.$el.html(this.template(data));
            this.show();
        } else {
            this.model.trigger('avatarUploadPrompt', this.target, this.options);
        }
        return this;
    }
});



// WEBPACK FOOTER //
// ./app/src/view/avatar-chooser-dialog.es6